"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The UpdateMyUserPasswordCommand model module.
 * @module model/UpdateMyUserPasswordCommand
 * @version 1.1.3-alpha.1
 */
class UpdateMyUserPasswordCommand {
  /**
   * Constructs a new <code>UpdateMyUserPasswordCommand</code>.
   * @alias module:model/UpdateMyUserPasswordCommand
   * @param current_password {String} 
   * @param new_password {String} 
   * @param confirm_password {String} 
   */
  constructor(current_password, new_password, confirm_password) {
    UpdateMyUserPasswordCommand.initialize(this, current_password, new_password, confirm_password);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, current_password, new_password, confirm_password) {
    obj['current_password'] = current_password;
    obj['new_password'] = new_password;
    obj['confirm_password'] = confirm_password;
  }

  /**
   * Constructs a <code>UpdateMyUserPasswordCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UpdateMyUserPasswordCommand} obj Optional instance to populate.
   * @return {module:model/UpdateMyUserPasswordCommand} The populated <code>UpdateMyUserPasswordCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UpdateMyUserPasswordCommand();
      if (data.hasOwnProperty('current_password')) {
        obj['current_password'] = _ApiClient.default.convertToType(data['current_password'], 'String');
      }
      if (data.hasOwnProperty('new_password')) {
        obj['new_password'] = _ApiClient.default.convertToType(data['new_password'], 'String');
      }
      if (data.hasOwnProperty('confirm_password')) {
        obj['confirm_password'] = _ApiClient.default.convertToType(data['confirm_password'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>UpdateMyUserPasswordCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateMyUserPasswordCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of UpdateMyUserPasswordCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['current_password'] && !(typeof data['current_password'] === 'string' || data['current_password'] instanceof String)) {
      throw new Error("Expected the field `current_password` to be a primitive type in the JSON string but got " + data['current_password']);
    }
    // ensure the json data is a string
    if (data['new_password'] && !(typeof data['new_password'] === 'string' || data['new_password'] instanceof String)) {
      throw new Error("Expected the field `new_password` to be a primitive type in the JSON string but got " + data['new_password']);
    }
    // ensure the json data is a string
    if (data['confirm_password'] && !(typeof data['confirm_password'] === 'string' || data['confirm_password'] instanceof String)) {
      throw new Error("Expected the field `confirm_password` to be a primitive type in the JSON string but got " + data['confirm_password']);
    }
    return true;
  }
}
UpdateMyUserPasswordCommand.RequiredProperties = ["current_password", "new_password", "confirm_password"];

/**
 * @member {String} current_password
 */
UpdateMyUserPasswordCommand.prototype['current_password'] = undefined;

/**
 * @member {String} new_password
 */
UpdateMyUserPasswordCommand.prototype['new_password'] = undefined;

/**
 * @member {String} confirm_password
 */
UpdateMyUserPasswordCommand.prototype['confirm_password'] = undefined;
var _default = exports.default = UpdateMyUserPasswordCommand;